import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Alert, Button, notification } from 'antd'

import { BILLING_SETTINGS } from '../modules/settings/utils/urls'
import { differenceInDays, isAfter } from 'date-fns'

let shown = false

const TrialBanner = ({ subscription, collapsed, windowWidth, isMobileDevice }) => {
	const [visible, setVisible] = React.useState(true)
	const history = useHistory()

	const { trialStartDate, isTrialPeriod, isActive, isPayingCustomer, end } = subscription || {}

	React.useEffect(() => {
		if (shown) return

		// If the subscription isn't active but the customer is a paying customer than their subscription has either expired or will expire.
		if (subscription && !isActive && isPayingCustomer) {
			const hasExpired = isAfter(new Date(), new Date(end))

			if (hasExpired) {
				notification.open({
					message: <span style={{ color: 'rgba(51, 68, 150, 1.0)' }}>Subscription Expired</span>,
					duration: 30,
					description: (
						<div>
							<p>
								Reactivate your account to get back to enjoying all that NeverWait has to offer.
							</p>
							<Button type="primary">Reactivate account</Button>
						</div>
					),
					onClick: () => {
						history.push('/settings/billing')
					},
				})
			}
		}

		shown = true
	}, [subscription])

	if (!visible) return null

	if (!subscription || !isTrialPeriod || differenceInDays(new Date(), trialStartDate) < 14) {
		return null
	}

	return (
		<Alert
			type="warning"
			banner
			closable
			style={{
				position: 'absolute',
				zIndex: 99,
				top: 0,
				width: windowWidth - (isMobileDevice ? 0 : collapsed ? 80 : 250),
				left: isMobileDevice ? 0 : collapsed ? 80 : 250,
			}}
			message={
				<span style={{ fontSize: 18, display: 'flex', alignItems: 'center' }}>
					Psst... Your trial period ends in {subscription.trialDaysRemaining} days. Subscribe today
					to prevent losing access to your account.
					<Link to={BILLING_SETTINGS} onClick={() => setVisible(false)}>
						<Button type="primary" ghost style={{ marginLeft: 7 }}>
							See Plans
						</Button>
					</Link>
				</span>
			}
		/>
	)
}

export default TrialBanner
